module.exports = __webpack_public_path__ + "static/media/lock_icon.a25d1be1.png";